import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const apiUrl = (path) => `${API}${path.startsWith('/') ? path : '/' + path}`;

// Resolve image URL: if backend-uploaded (/api/uploads/xxx), prepend BACKEND_URL
export const resolveImg = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  if (url.startsWith('/api/')) return `${BACKEND_URL}${url}`;
  return url;
};

export default api;
